"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletePopUpLayout = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../common");
const popup_1 = require("../popup");
/**
 * DS-T-L-001: 삭제 안내 팝업 (DS-POPUP-022)
 */
exports.DeletePopUpLayout = react_1.default.memo(({ deleteContent, isQnA = false, showCancel = true, previosPage, onDelete, onRegist, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const closePopup = () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, undefined);
    const handlerDelete = () => {
        onDelete && onDelete();
        APP.eventManager.publish(popup_1.TOGGLE_POPUP);
        APP.eventManager.publish('SUCCESS_DELETE');
    };
    return (react_1.default.createElement("div", { className: "flex column center" },
        react_1.default.createElement("div", { className: "body1", style: {
                whiteSpace: 'break-spaces',
                textAlign: 'center',
            } }, deleteContent),
        react_1.default.createElement("div", { className: "btn-container" },
            react_1.default.createElement(common_1.Button, { className: "btn_default sm", text: t('common.okay'), onClick: onDelete
                    ? isQnA
                        ? onDelete
                        : handlerDelete
                    : onRegist
                        ? onRegist
                        : previosPage
                            ? previosPage
                            : closePopup }),
            showCancel && (react_1.default.createElement(common_1.Button, { className: "btn_white sm", text: t('common.cancel'), onClick: closePopup })))));
});
